import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { TableParams } from '@swf/generated/types/api/v0/SwHomeGames';
import { HandTypeTranslations } from '@swf/poker';

import { fallback } from '../utils/common';

import { TXTCLI_H_L } from './useGetGameOptions.messages.json';

const useGetGameOptions = (gameData: TableParams[]) => {
  const { formatMessage } = useIntl();
  return useMemo(() => {
    if (!gameData || !gameData.length) return fallback;

    const games = [...new Set(gameData.map((item) => item.handType))];
    const gamesHiLo = [
      ...new Set(gameData.filter((item) => item.hiLo).map((item) => item.handType))
    ];

    games.sort((a, b) => {
      if (a === 'HT_HOLDEM') return -1;
      if (b === 'HT_HOLDEM') return 1;
      return 0;
    });

    const gameOptions = games.map((handType) => ({
      text: formatMessage(HandTypeTranslations[handType as string]),
      value: JSON.stringify({ handType, hiLo: false })
    }));

    const hiLoGameOptions = gamesHiLo.map((handType) => ({
      text: `${formatMessage(HandTypeTranslations[handType as string])} ${formatMessage(
        TXTCLI_H_L
      )}`,
      value: JSON.stringify({ handType, hiLo: true })
    }));

    const options = [...gameOptions, ...hiLoGameOptions];

    if (!options || !options.length) return fallback;

    return options;
  }, [gameData, formatMessage]);
};

export default useGetGameOptions;
